import { useMemo } from 'react';

import { MATCHDAY_COUNT, SWAP_MATCHDAY } from '@/constants';
import { useMatchdayConfig } from '@/hooks/useMatchdayConfig';
import { useProgressionAwards } from '@/hooks/useProgressionAwards';
import type { ProgressionAward } from '@/models/scoring';

/** Live tournament inputs shared by AI League leaderboard and standings chart scoring. */
export interface AiLeagueScoringContext {
  settledMatchday: number;
  matchdayCount: number;
  swapMatchday: number;
  progressionAwards: ProgressionAward[];
}

export function useAiLeagueScoringContext(): AiLeagueScoringContext {
  const config = useMatchdayConfig();
  const progressionAwards = useProgressionAwards();

  return useMemo(
    () => ({
      settledMatchday: config?.currentMatchday ?? 0,
      matchdayCount: config?.matchdayCount ?? MATCHDAY_COUNT,
      swapMatchday: config?.swapMatchday ?? SWAP_MATCHDAY,
      progressionAwards,
    }),
    [config, progressionAwards],
  );
}
